import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Antigravity (Google) mark, used in our UI to represent the `agy` CLI agent.
 *
 * Source: Boxicons "google-antigravity" (MIT — © Boxicons).
 */
@Component({
  selector: 'zui-antigravity-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true">
      <path d="M19.94 20.59c1.09.82 2.73.27 1.23-1.23C16.67 15 17.62 3 12.03 3S7.39 15 2.89 19.36c-1.64 1.64.14 2.05 1.23 1.23c4.23-2.86 3.95-7.91 7.91-7.91s3.68 5.05 7.91 7.91" />
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 0;
    }

    svg {
      display: block;
    }
  `
})
export class ZuiAntigravityMarkComponent {}
